import React, { Component } from 'react';
import $ from 'jquery';

class ItemInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      show: false
    };
  }

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  // create item to add if it respect a certain condition
  keyPressOnItemInput = e => {
    const patt = /^[a-zA-ZñÑ0-9]+([a-zA-ZñÑ0-9 ]*$)/;
    let result = patt.test(e.target.value);

    if (e.keyCode === 13) {
      if (result) {
        this.props.handleAddNewItemToSave(e.target.value);
        setTimeout(function(){$("#fname").blur(); $("#fname").focus(); }, 1);
        this.setState({ value: '', show: false });
      } else {
        this.setState({ show: true });
      }
    } else if (e.keyCode === 27) {
      this.setState({ value: '', show: false });
    }
  };

  hadleBlur = e => {
    this.setState({ value: '' });
  };

  render() {
    const {
      listName,
      items,
      handleEditButton,
      handleDeleteButton
    } = this.props;

    let result = '';
    if (items.datos && items.datos.length > 0) {
       result = items.datos.map((item, i) => {
        return (
          <li
            key={i}
            className={`${
              item.id==null ? 'not-created-item' :
                item.delete ? 'item-to-delete' :
                item.update ? 'item-to-update' : ''
            }`}>
            {item.update ? item.editedValue : item.name}
            <span className="icon-delete">
              <i
                className="fas fa-times-circle"
                onClick={handleDeleteButton}
                data-id={item.id}
                data-name={item.name}
                data-delete={item.delete ? 1 : 0}
              />
            </span>
            {item.id && (
              <span className={`icon-edit`}>
                <i
                  className="fas fa-edit"
                  onClick={handleEditButton}
                  data-id={item.id}
                  data-name={item.name}
                  data-update={item.update ? 1 : 0}
                />
              </span>
            )}
          </li>
        );
      });
    }
    return (
      <div className="input-container">
        <ul>
          <li>
            <ul className="item-list">{result}</ul>
          </li>

          <li className="uper-input-label">
            <input
              type="text"
              className={`${this.state.show ? 'input-out-line' : ''}`}
              id="fname"
              name="lista"
              placeholder={
                this.props.language.card.item.placeholder +
                " " + listName
              }
              value={this.state.value}
              onChange={this.handleChange}
              onKeyDown={this.keyPressOnItemInput}
              onBlur={this.hadleBlur}
              autoComplete="off"
            />
            <ul>
              <li className="popup-container">
                <div className={`popup ${this.state.show ? 'show' : ''}`}>
                  <span className="popuptext" id="myPopup">
                    {this.props.language.card.item.label_alert}
                  </span>
                </div>
              </li>
            </ul>
          </li>
          <li className="under-input-label">{this.props.language.card.item.label}</li>
        </ul>
      </div>
    );
  }
}
export default ItemInput;



// WEBPACK FOOTER //
// ./source/client/components/account_list/itemInput.jsx